import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { CurrencyCustomPipe } from './../../../pipe/currency-custom.pipe';

@Component({
  selector: 'app-ion-common-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss'],
})
export class InputCurrencyComponent {

  @ViewChild('inputCurrency') inputCurrency: ElementRef;
  @Input()
  idIncome = 'inputIncome';
  @Input()
  label = 'Renda e patrimônio';
  @Input()
  placeholder = 'R$ 00,00';
  @Input()
  currencyLabel = 'R$';
  @Input()
  inputTextValue = '';
  @Output()
  sendValueInput = new EventEmitter<string>();
  hideStatusResult = true;
  statusResult = '';
  @Input()
  disabled: boolean;


  updateValue($event: any) {
    const pipe = new CurrencyCustomPipe();
    const valueTransform = pipe.transform($event.target.value.replace(/\D/g, ''));
    $event.target.value = valueTransform;
    this.inputTextValue = $event.target.value;
    this.sendValueInput.emit(this.inputTextValue.replace(`${this.currencyLabel} `, ''));
  }

  submitInput() {
    this.inputCurrency.nativeElement.blur();
    setTimeout(() => this.inputCurrency.nativeElement.focus(), 200);
  }

  setStatusResult($event: any) {
    if ($event.which !== 13) {
      setTimeout(() => {
        this.statusResult = $event.target.value;
        this.hideStatusResult = false;
        setTimeout(() => {
          this.hideStatusResult = true;
          this.statusResult = '';
        }, 2000);
      }, 1000);
    }
  }

}
